import { createSlice, PayloadAction, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { machineStateApi } from "./api";
import { AlarmData} from "../Common/Types/types";
import { RootState } from "../Core/Store";

const initialMachineTimes:any = [];

interface machineTimesSliceState {
    machineTimes:any[];
    loadingState?: string;
    errorMessage?: string;
}

const initialState: machineTimesSliceState = {
    machineTimes:initialMachineTimes,
    loadingState: undefined,
    errorMessage: undefined,
};

export const fetchMachineTimes = createAsyncThunk<any,any>(
    "machineTimes/fetchMachineTimes",
    async (params:any) => {
      const response = await machineStateApi.fetchMachineTimes(params)
      //
      return response;
    }
); 


const machineTimesSlice = createSlice({
    name: "machineTimes",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      //
      builder.addCase(fetchMachineTimes.fulfilled, (state, action) => {
        return {
          ...state,
          loadingState: "fulfilled",
          errorMessage: undefined,
          machineTimes: action.payload,
        };
      });
      builder.addCase(fetchMachineTimes.rejected, (state, action) => {
        return {
          ...state,
          loadingState: "rejected",
          errorMessage: "error",
        };
      });
      builder.addCase(fetchMachineTimes.pending, (state, action) => {
        return {
          ...state,
          loadingState: "pending",
          errorMessage: undefined,
        };
      });
    },
  });
  
export const getMachineTimesSelector = (state: RootState) => state.machineTimes.machineTimes;
export const getMachineTimesLoadingSelector = (state: RootState) => state.machineTimes.loadingState;

export default machineTimesSlice.reducer;